// 买一送一插件弹窗
(function () {
  // let URL = "https://gateway.di79.com"
  let URL = "https://gateway.antdiy.vip"
  // 是否打开监控
  let isMonitor = true
  let metaBox = document.createElement("meta")
  metaBox.name = "referrer"
  metaBox.content = "no-referrer"
  document.head.appendChild(metaBox);

  var foAdd, foSubtract, foMultiply, foDivide;
  let myUUID = localStorage.getItem("uid")
  if (!myUUID) {
    myUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    localStorage.setItem("uid", myUUID);
  }
  let result = new URLSearchParams(window.location.search);
  let source = sessionStorage.getItem('LiqSource');
  let resultSource = result.get('source')
  if (resultSource) {
    source = resultSource
  }

  // 加减乘除计算方法
  function isInteger(obj) {
    return Math.floor(obj) === obj
  }
  function toInteger(floatNum) {
    var ret = { times: 1, num: 0 };
    if (isInteger(floatNum)) {
      ret.num = floatNum;
      return ret
    }
    var strfi = floatNum + '';
    var dotPos = strfi.indexOf('.');
    var len = strfi.substr(dotPos + 1).length;
    var times = Math.pow(10, len);
    var intNum = parseInt(floatNum * times + 0.5, 10);
    ret.times = times;
    ret.num = intNum;
    return ret
  }
  function operation(a, b, op) {
    var o1 = toInteger(a);
    var o2 = toInteger(b);
    var n1 = o1.num;
    var n2 = o2.num;
    var t1 = o1.times;
    var t2 = o2.times;
    var max = t1 > t2 ? t1 : t2;
    var result = null;
    switch (op) {
      case 'add':
        if (t1 === t2) { // 两个小数位数相同
          result = n1 + n2
        } else if (t1 > t2) { // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2)
        } else if (n1 * t2 < 0) {
          result = n2 - n1
        } else { // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2
        }
        return result / max;
      case 'subtract':
        if (t1 === t2) {
          result = n1 - n2
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2)
        } else {
          result = n1 * (t2 / t1) - n2
        }
        return result / max;
      case 'multiply':
        result = (n1 * n2) / (t1 * t2);
        return result;
      case 'divide':
        result = (n1 * t2) / (n2 * t1);
        return result
    }
  }
  // 加减乘除的四个接口
  foAdd = (a, b) => {
    return operation(a * 1, b * 1, 'add')
  }

  foSubtract = (a, b) => {
    return operation(a * 1, b * 1, 'subtract')
  }

  foMultiply = (a, b) => {
    return operation(a * 1, b * 1, 'multiply')
  }

  foDivide = (a, b) => {
    return operation(a * 1, b * 1, 'divide')
  }

  // 不同国家钱符号
  let currencyList = {
    "AED": ".د.ب",
    "ALL": "lek",
    "AOA": "Kz",
    "ARS": "$",
    "AUD": "$",
    "AWG": "ƒ",
    "AZN": "ман",
    "BAM": "KM",
    "BBD": "$",
    "BDT": "Tk",
    "BGN": "лв",
    "BHD": ".د.ب or BD",
    "BMD": "$",
    "BND": "$",
    "BOB": "$b",
    "BRL": "R$",
    "BSD": "B$",
    "BTN": "Nu.",
    "BWP": "P",
    "BYN": "р",
    "BZD": "BZ$",
    "CAD": "$",
    "CHF": "CHF",
    "CLP": "$",
    "CNY": "¥",
    "COP": "$",
    "CRC": "₡",
    "CUC": "$",
    "CUP": "₱",
    "CVE": "$",
    "CZK": "Kč",
    "DJF": "fdj",
    "DKK": "kr",
    "DOP": "$",
    "DZD": "جد",
    "EGP": "£ ",
    "ERN": "ናቕፋ",
    "ETB": "Br",
    "EUR": "€",
    "FJD": "$",
    "FKP": "£",
    "GBP": "£",
    "GEL": "ლ",
    "GHS": "GH¢",
    "GIP": "£",
    "GTQ": "Q",
    "GYD": "$",
    "HKD": "HK$",
    "HNL": "L",
    "HRK": "kn",
    "HTG": "G",
    "HUF": "Ft",
    "IDR": "Rp",
    "ILS": "₪",
    "INR": "₹",
    "IQD": "ع.د",
    "ISK": "kr",
    "JMD": "J$",
    "JPY": "¥",
    "KES": "KSh",
    "KGS": "лв",
    "KHR": "៛",
    "KPW": "₩",
    "KRW": "₩",
    "KWD": "ك",
    "KYD": "$",
    "KZT": "₸",
    "LAK": "₭",
    "LBP": "ل.ل",
    "LKR": "Rs",
    "LRD": "$",
    "LSL": "L or M",
    "LTL": "Lt",
    "LYD": " د.ل",
    "MAD": "م.د.",
    "MDL": "L",
    "MGA": "Ar",
    "MKD": "ден",
    "MMK": "K",
    "MNT": "₮",
    "MOP": "MOP$",
    "MRO": "UM",
    "MUR": "Rs",
    "MVR": "rf",
    "MWK": "MK",
    "MXN": "$",
    "MYR": "RM",
    "MZN": "MT",
    "NAD": "$",
    "NGN": "₦",
    "NIO": "C$",
    "NOK": "kr",
    "NPR": "Rs",
    "NZD": "$",
    "OMR": "ع.ر.",
    "PAB": "B/",
    "PEN": "S/",
    "PGK": "K",
    "PHP": "₱",
    "PKR": "Rs",
    "PLN": "zł",
    "QAR": "ق.ر ",
    "RON": "lei",
    "RSD": "РСД",
    "RUB": "₽",
    "RWF": "FRw, RF, R₣",
    "SAR": "SAR",
    "SBD": "SI$",
    "SCR": "Rs",
    "SEK": "kr",
    "SGD": "$",
    "SLL": "Le",
    "SOS": "S",
    "SRD": "$",
    "SYP": "£",
    "SZL": "L or E",
    "THB": "฿",
    "TMT": "T",
    "TOP": "T$",
    "TRY": "₺",
    "TTD": "TT$",
    "TWD": "NT$",
    "TZS": "Sh",
    "UAH": "₴",
    "UGX": "USh",
    "USD": "$",
    "UYU": "$U",
    "UZS": "лв",
    "VEF": "Bs",
    "VND": "₫",
    "VUV": "VT",
    "WST": "$",
    "XCD": "EC$",
    "ZAR": "R",
    "ZMW": "ZMK"
  }
  // 不同国家语言文字
  let languageData = {
    RON: {
      lT1p1: 'RON',
      b1yT1x2: 'Cumpărați cu Ramburs la Livrare',
      l1y0u3t1: 'initial',
      p0p6p8a1d: 'Comanda cu Ramburs la Livrare',
      d1l1v1ry: 'Metodă de livrare',
      fr11t2an: 'Transport gratuit',
      fr11t1xt: 'Gratuit',
      a66r133: 'Introdu adresa ta de livrare',
      f411n1m1: 'Numele complet',
      e11o1: 'Acest câmp este obligatoriu.',
      em21l1rr0: 'Introduceți o adresă de email validă.',
      t1l1: 'Telefon',
      ex12t: 'Numele strade',
      ex12t9l1: 'ex: Strada Principal',
      b41ld: 'Numărul casei',
      b41ld9l1: 'Numărul casei, Bloc, Scara, Etaj, Apartament',
      c04nt1: 'Județ',
      t0w5: 'Oraș',
      p03t1l: 'Cod postal',
      em21l: 'E-mail',
      o2d128t: 'Finalizați achiziția',
      o2d1r122: 'Order failure',
      ph0n1122: 'Introduceți un număr de telefon valid',
      r1d4c1r1: 'Reduceri',
      o2d123u99: 'Comandat cu succes',
    },
    SAR: {
      lT1p1: 'SAR',
      b1yT1x2: 'اشتر الآن（الدفع عند الاستلام ）',
      l1y0u3t1: 'rtl',
      p0p6p8a1d: "الطلب نقدًا عند التسليم",
      d1l1v1ry: 'طريقة التوصيل',
      fr11t2an: 'النقل مجاني',
      fr11t1xt: 'حر',
      a66r133: 'أدخل عنوان التسليم الخاص بك',
      f411n1m1: 'الاسم الكامل',
      e11o1: 'هذه الخانة مطلوبه.',
      em21l1rr0: 'أدخل عنوان بريد إلكتروني صالح.',
      t1l1: 'هاتف',
      ex12t: 'العنوان التفصيلي',
      ex12t9l1: '3القطعة/الشارع/المنزل: قطعة 5 شارع 2منزل',
      b41ld: 'رقم الدار',
      c04nt1: 'المحافظة',
      t0w5: 'المدينة',
      p03t1l: 'الرمز البريدي',
      em21l: 'بريد إلكتروني',
      o2d128t: 'أكمل عملية الشراء',
      o2d1r122: 'فشل الطلب',
      r1d4c1r1: 'خصومات',
      o2d123u99: 'تم الطلب بنجاح',
    },
    KLDY: {
      lT1p1: 'KLDY',
      b1yT1x2: 'Kupujte pouzećem',
      l1y0u3t1: 'početno',
      p0p6p8a1d: 'Naruči s plaćanjem pouzećem',
      d1l1v1ry: 'Način isporuke',
      fr11t2an: 'Besplatna dostava',
      fr11t1xt: 'Besplatno',
      a66r133: 'Unesite svoju adresu za dostavu',
      f411n1m1: 'Puno ime',
      e11o1: 'Ovo polje je obavezno.',
      em21l1rr0: 'Unesite valjanu adresu e-pošte.',
      t1l1: 'Telefon',
      ex12t: 'Ime ulice',
      ex12t9l1: 'ex: Glavna ulica',
      b41ld: 'Kućni broj',
      b41ld9l1: 'Kućni broj, blok, stepenište, kat, stan',
      c04nt1: 'Okrug',
      t0w5: 'Grad',
      p03t1l: 'Poštanski broj',
      em21l: 'E-mail',
      o2d128t: 'Dovrši kupnju',
      o2d1r122: 'Narudžba nije uspjela',
      ph0n1122: 'Unesite važeći broj telefona',
      r1d4c1r1: 'Popusti',
      o2d123u99: 'Uspješno naručeno',
    },
    BJLY: {
      lT1p1: "BJLY",
      b1yT1x2: 'Купете с наложен платеж',
      l1y0u3t1: 'начален',
      p0p6p8a1d: 'Поръчай с наложен платеж',
      d1l1v1ry: 'Начин на доставка',
      fr11t2an: 'Безплатна доставка',
      fr11t1xt: "Безплатно",
      a66r133: 'Въведете вашия адрес за доставка',
      f411n1m1: 'Пълно име',
      e11o1: 'Това поле е задължително.',
      em21l1rr0: 'Въведете валиден имейл адрес.',
      t1l1: "Телефон",
      ex12t: 'Име на улица',
      ex12t9l1: 'ex: Главна улица',
      b41ld: "номер на къща",
      b41ld9l1: 'номер на къща, блок, стълбище, етаж, апартамент',
      c04nt1: 'Окръг',
      t0w5: "Град",
      p03t1l: "Пощенски код",
      em21l: 'Имейл',
      o2d128t: 'Завършена покупка',
      o2d1r122: 'Неуспешна поръчка',
      ph0n1122: 'Въведете валиден телефонен номер',
      r1d4c1r1: 'Отстъпки',
      o2d123u99: 'Поръчано успешно',
    },
    SLWNY: {
      lT1p1: 'SLWNY',
      b1yT1x2: 'Kupujte z gotovino ob dostavi',
      l1y0u3t1: 'začetnica',
      p0p6p8a1d: 'Naroči z gotovino ob dostavi',
      d1l1v1ry: 'Način dostave',
      fr11t2an: 'Brezplačna dostava',
      fr11t1xt: 'Brezplačno',
      a66r133: 'Vnesite naslov za dostavo',
      f411n1m1: 'Polno ime',
      e11o1: 'To polje je obvezno.',
      em21l1rr0: 'Vnesite veljaven e-poštni naslov.',
      t1l1: 'Telefon',
      ex12t: 'Ime ulice',
      ex12t9l1: 'ex: Glavna ulica',
      b41ld: 'Hišna številka',
      b41ld9l1: 'Hišna številka, blok, stopnišče, nadstropje, stanovanje',
      c04nt1: 'Okrožje',
      t0w5: 'Mesto',
      p03t1l: 'Poštna številka',
      em21l: 'E-pošta',
      o2d128t: 'Dokončan nakup',
      o2d1r122: 'Naročilo ni uspelo',
      ph0n1122: 'Vnesite veljavno telefonsko številko',
      r1d4c1r1: 'Popusti',
      o2d123u99: 'Uspešno naročeno',
    }
  }
  let currencyValue = Shopify?.currency?.active
  // -----------------------------------------------------------------语言固定修改--------------------------------------------------------------------------------------
  // let LText = languageData.RON
  let LText = languageData[currencyValue] || languageData.RON

  // 显示位置 0结算页1商品详情
  let pPosition = 0
  // 产品数据
  let productList = []
  // 产品SKU数据
  let productSkuList = []
  // 选择sku列表
  let skuData = []
  // 是否是优惠商品
  let isDiscounts = false
  // 原价
  let original = 0;
  // 折扣
  let discountPrice;
  // 折扣后价格
  let total;
  // 商品名称
  let title;
  // 商品ID
  let productId = ''
  // 购买按钮
  let buyBtn = document.querySelector('.cod_checkout_btn');
  let buyBottomBtn = document.querySelector('.cod_bottom_button');
  // 变体元素
  let variantDiv = document.querySelector('.cod_variant_list')

  sendXgtag({ event_name: "PageView" });
  // 下单按钮点击事件
  if (buyBtn) {
    buyBtn.addEventListener('click', (e) => {
      clickBuyBtn()
    })
  }
  if (buyBottomBtn) {
    buyBottomBtn.addEventListener('click', (e) => {
      clickBuyBtn()
    })
  }
  // 初始化数据
  initializeData()
  async function initializeData() {
    let shopData = meta.product
    // 产品详情页
    if (window.location.pathname.indexOf('/products/') > -1) {
      productId = shopData.id
    } else {
      // 首页热销品
      let productInp = document.querySelector('[name="product-id"]')
      if (productInp) {
        productId = productInp.getAttribute("value")
      }
    }
    if (productId) {
      let res = await getSKUData();
      if (res.success && res.data && res.data.combined_sale_responses && res.data.product_sku_list) {
        res.data.combined_sale_responses.forEach(item => {
          item.sku_options = item.sku_options || []
          item.sku_options.map((val) => {
            val.sku_options = val.sku_options || []
            val.sku_options.map(pop => {
              if (pop.value.includes('M') || pop.value.includes('L') || pop.value.includes('XL') || pop.value.includes('2X') || pop.value.includes('3XL')) {
                pop.value = pop.value.reverse()
              }
            })
          })
        })
        productList = res.data.combined_sale_responses || []
        productSkuList = res.data.product_sku_list || []
        title = res.data.title
        isDiscounts = true
        if (variantDiv && res.data.page_position == 1) {
          pPosition = res.data.page_position
          let productDiv = addVariant()
          variantDiv.innerHTML = productDiv
          let priceBox = document.querySelector('.product__info-container .price')
          if (priceBox) priceBox.style.display = 'none'
          dBindClick()
        }
      }
      if (!isDiscounts) {
        let variantRadios = document.querySelector('variant-radios')
        let variantSelects = document.querySelector('variant-selects')
        if (variantRadios) variantRadios.style.display = 'block'
        if (variantSelects) variantSelects.style.display = 'block'
      }
    }
  }

  // 添加变体元素
  function addVariant() {
    let productDiv = '';
    // 原价
    original = 0;
    // 折扣
    discountPrice = 0;
    // 折扣后价格
    total = 0;
    // 平均价
    let average = 0;
    let discountObj = productList.filter(i => i.default)[0]
    productList.forEach((item, index) => {
      item.productLiBottom = ''
      if (discountObj && item.name === discountObj.name) {
        item.defaultOpen = true
      } else if (!discountObj && index === 0) {
        item.defaultOpen = true
      }
      item.sku_options.map((val, ind) => {
        if (item.defaultOpen) {
          discountPrice = item.price
          selectSku(index, val.sku_options, ind, true)
        }
        val.skuLi = ''
        val.sku_options.map(pop => {
          pop.optionBox = ''
          pop.value.map(option => {
            pop.optionBox += `<option value="${option}">${option}</option>`
          })
          val.skuLi += `<div class="pop_sku_li">
                <span>${pop.name}</span>
                <select class="pop_sku_select" name="${pop.name}" index="${index}" ind="${ind}">${pop.optionBox}</select>
              </div>`
        })
        item.productLiBottom += `<div class="pop_sku_num_li">
              <div class="pop_sku_num">${ind + 1}.</div>
              <div class="pop_sku_list">${val.skuLi}</div>
            </div>`
      })
    })
    for (let i = 0; i < skuData.length; i++) {
      original = foAdd(original, Number(skuData[i].price))
    }
    average = foDivide(original, skuData.length)
    productList.map((item, index) => {
      item.price_tag = foMultiply(average, item.sku_options.length)
      item.dPrice = foSubtract(item.price_tag, Number(item.price) || 0)
      if (item.defaultOpen) {
        total = item.dPrice
      }
      productDiv += `<div class="pop_up_product_li${item.defaultOpen ? ' product_li_active' : ''}">
            <div class="product_li_top" discount=${item.price} key=${index} price_tag=${item.price_tag} price=${item.dPrice}>
              <div class="product_img">${skuData[0].image ? `<img src="${skuData[0].image}" />` : ''}</div>
              <div class="product_info">
                <span class="product_info_num">${item.name}</span>
              </div>
              <div class="product_price">
                ${Number(item.price) ? `<i>${item.price_tag} ${currencyValue}</i>` : ''}
                <span class="span_price">${item.dPrice} ${currencyValue}</span>
              </div>
            </div>
            <div class="product_li_bottom">${item.productLiBottom}</div>
          </div>`
    })
    return productDiv
  }

  // 添加下单弹窗
  function clickBuyBtn() {
    let result = new URLSearchParams(window.location.search);
    let variant = result.get('variant');
    let shopData = meta.product
    let variant_id = ''
    // 产品详情页
    if (window.location.pathname.indexOf('/products/') > -1) {
      variant_id = variant ? variant : shopData.variants[0].id
      productId = shopData.id
    } else {
      // 首页热销品
      let variantBox = document.getElementsByName('id')
      if (variantBox && variantBox.length > 0) {
        variant_id = variantBox[variantBox.length - 1].value
      }
      let productInp = document.querySelector('[name="product-id"]')
      if (productInp) {
        productId = productInp.getAttribute("value")
      }
    }
    if (productId && variant_id) {
      let quantityNum = document.querySelector('.quantity__input')?.value || '1'
      createPopUp(variant_id, '1')
    }
  }

  // 关闭Loading按钮
  function closeLoading(dom) {
    dom.querySelector('.cod_loading_icon').style.display = 'none'
    document.querySelector('.pop_up_checkout_btn').className = 'pop_up_checkout_btn'
  }

  // 创建下单弹窗
  function createPopUp(variant_id, quantityNum) {
    let codPopUp = document.createElement('div');
    codPopUp.innerHTML = `<div class="cod_pop_up" id="cod_pop_up" style="direction: ${LText.l1y0u3t1};">
      <div class="pop_up_box">
        <div class="pop_up_header">
          <span>${LText.p0p6p8a1d}</span>
          <svg id='pop_up_close' class="pop_up_close" width="22px" height="22px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>关闭icon</title>
            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="相似清单" transform="translate(-1516.000000, -682.000000)" fill="#000000">
                    <g id="编组-18" transform="translate(360.000000, 644.000000)">
                        <g id="编组-15" transform="translate(1156.000000, 38.000000)">
                            <path d="M11.0117187,10 L16.1386719,3.88867188 C16.2246094,3.78710938 16.1523437,3.6328125 16.0195312,3.6328125 L14.4609375,3.6328125 C14.3691406,3.6328125 14.28125,3.67382813 14.2207031,3.74414063 L9.9921875,8.78515625 L5.76367187,3.74414062 C5.70507812,3.67382812 5.6171875,3.6328125 5.5234375,3.6328125 L3.96484375,3.6328125 C3.83203125,3.6328125 3.75976562,3.78710938 3.84570312,3.88867188 L8.97265625,10 L3.84570312,16.1113281 C3.75976562,16.2128906 3.83203125,16.3671875 3.96484375,16.3671875 L5.5234375,16.3671875 C5.61523437,16.3671875 5.703125,16.3261719 5.76367187,16.2558594 L9.9921875,11.2148437 L14.2207031,16.2558594 C14.2792969,16.3261719 14.3671875,16.3671875 14.4609375,16.3671875 L16.0195312,16.3671875 C16.1523437,16.3671875 16.2246094,16.2128906 16.1386719,16.1113281 L11.0117187,10 Z" id="路径" fill-opacity="0.45"></path>
                            <rect id="矩形" fill-rule="nonzero" opacity="0" x="0" y="0" width="20" height="20"></rect>
                        </g>
                    </g>
                </g>
              </g>
          </svg>
        </div>
        <div class="pop_up_content">
          <div class="pop_up_loading">
            <img src="https://platform.antdiy.vip/static/image/hydrogen_loading.gif" />
              </div>
          <div class="pop_up_isshow">
          </div>
          <div class="pop_up_from">
            <div class="pop_up_from_title">${LText.a66r133}</div>
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.f411n1m1}</span>
                <i>*</i>
              </div>
              <input id="cod_name" type="text" placeholder="${LText.f411n1m1}">
              <div id="name_error" class="error_text">${LText.e11o1}</div>
            </div>
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.t1l1}</span>
                <i>*</i>
              </div>
              <input id="cod_phone" type="number" placeholder="${LText.t1l1}">
              <div id="phone_error" class="error_text">${LText.e11o1}</div>
            </div>
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.ex12t}</span>
                <i>*</i>
              </div>
              <input id="cod_area" type="text" placeholder="${LText.ex12t9l1}">
              <div id="area_error" class="error_text">${LText.e11o1}</div>
            </div>
            ${LText.lT1p1 === 'RON' ? `<div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.b41ld}</span>
                <i>*</i>
              </div>
              <input id="cod_house_number" type="text" placeholder="${LText.b41ld9l1}">
              <div id="house_number_error" class="error_text">${LText.e11o1}</div>
            </div>` : ''}
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.c04nt1}</span>
                <i>*</i>
              </div>
              <input id="cod_state" type="text" placeholder="${LText.c04nt1}">
              <div id="state_error" class="error_text">${LText.e11o1}</div>
            </div>
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.t0w5}</span>
                <i>*</i>
              </div>
              <input id="cod_city" type="text" placeholder="${LText.t0w5}">
              <div id="city_error" class="error_text">${LText.e11o1}</div>
            </div>
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.p03t1l}</span>
                <i></i>
              </div>
              <input id="cod_postcode" type="number" placeholder="${LText.p03t1l}">
            </div>
            <div class="pop_up_from_item">
              <div class="item_title">
                <span>${LText.em21l}</span>
                <i></i>
              </div>
              <input id="cod_email" type="text" placeholder="${LText.em21l}">
              <div id="email_error" class="error_text">${LText.em21l1rr0}</div>
            </div>
          </div>
          <div class="pop_up_checkout_btn" id="pop_up_checkout_btn">
            <span class="pop_up_checkout_price">${LText.o2d128t} - ${LText.o2d128t}</span>
            <div class="cod_loading_icon"><img src="https://platform.antdiy.vip/static/image/hydrogen_loading.gif" /></div>
          </div>
        </div>
        <div class="order_success">${LText.o2d123u99}!</div>
      </div>
    </div>`
    document.body.appendChild(codPopUp)

    // 获取产品数据列表
    getProductList(variant_id, quantityNum)

    // 点击关闭按钮
    let closePopUp = document.getElementById('pop_up_close')
    closePopUp.addEventListener('click', () => {
      codPopUp.remove()
    })

    // 控制输入数字
    let codPostCode = document.querySelector(`#cod_postcode`)
    let codPhone = document.querySelector(`#cod_phone`)
    const regex = /[^0-9]/g;
    codPostCode.addEventListener('input', function (event) {
      codPostCode.value = codPostCode.value.replace(regex, '');
    });
    codPhone.addEventListener('input', function (event) {
      // if (codPhone.value.length > 10) {
      //   codPhone.value = codPhone.value.slice(0, 10)
      // } else {
      //   codPhone.value = codPhone.value.replace(regex, '');
      // }
      codPhone.value = codPhone.value.replace(regex, '');
    });
    let inpList = document.querySelector('.pop_up_from').getElementsByTagName('input')
    if (inpList && inpList.length > 0) {
      Array.from(inpList).forEach(item => {
        item.addEventListener('blur', function (event) {
          if (item.value) {
            sendXgtag({
              event_name: "formInput",
              event_label: item.id,
              event_value: item.value,
            });
          }
        });
      })
    }
  }

  // 商品信息数据
  function createProduct() {
    let productDiv = '';
    if (isDiscounts) {
      if (pPosition) {
        skuData.map(item => {
          let skuname = item.skuinfo_list?.map(i => { return i.value })?.join(' / ')
          productDiv += `<div class="pop_up_product_li flex_li">
          <div class="product_img"><img src="${item.image}" /></div>
          <div class="product_info">
            <span class="product_info_title">${title}</span>
            <span class="product_info_variant_name">${skuname}</span>
          </div>
          <div class="product_price">${item.price} ${currencyValue}</div>
        </div>`
        })
      } else {
        productDiv = addVariant()
      }
    } else {
      productList.map(item => {
        productDiv += `<div class="pop_up_product_li flex_li">
        <div class="product_img"><img src="${item.img}" /><div class="product_count">${item.quantity}</div></div>
        <div class="product_info">
          <a class="product_info_title" href="${item.href}">${item.title}</a>
          <span class="product_info_variant_name">${item.variant_title}</span>
        </div>
        <div class="product_price">${item.price} ${item.unit}</div>
      </div>`
      })
      total = productList[0].total_price ? productList[0].total_price : productList[0].price
      original = total
    }

    let popUpIsshow = document.querySelector('.pop_up_isshow')
    let popUpLoading = document.querySelector('.pop_up_loading')
    if (popUpIsshow) {
      popUpIsshow.innerHTML = `
        <div class="pop_up_product">
          <div class="pop_up_product_list">${productDiv}</div>
          <div class="pop_up_summary">
            <div class="pop_up_summary_line">
              <span class="line_title">Subtotal</span>
              <span class="line_value subtotal_price">${original} ${currencyValue}</span>
            </div>
            <div class="pop_up_summary_line">
              <span class="line_title">Shipping</span>
              <span class="line_value">${LText.fr11t1xt}</span>
            </div>
            <div class="pop_up_summary_line pop_up_summary_discount">
              <span class="line_title">${LText.r1d4c1r1}</span>
              <span class="line_value red_line_value">-${discountPrice} ${currencyValue}</span>
            </div>
            <div class="pop_up_summary_line pop_up_summary_bigger">
              <span class="line_title">Total</span>
              <span class="line_value total_price">${total} ${currencyValue}</span>
            </div>
          </div>
        </div>
        <div class="pop_up_shipping">
          <div class="title">${LText.d1l1v1ry}</div>
          <div class="rates">
            <div class="rates_item_choice"></div>
            <span class="rates_item_title">${LText.fr11t2an}</span>
            <span class="price">${LText.fr11t1xt}</span>
          </div>
        </div>`
      document.querySelector('.pop_up_checkout_price').innerHTML = `${LText.o2d128t} - ${total} ${currencyValue}`
      popUpIsshow.style.display = 'block'
      popUpLoading.style.display = 'none'
      document.querySelector('.cod_loading_icon').style.background = 'rgba(0, 0, 0, 0.6)'
      document.querySelector('.cod_loading_icon').style.display = 'none'

      let discountLine = document.querySelector('.pop_up_summary_discount')
      discountLine.style.display = Number(discountPrice) ? 'flex' : 'none'
      if (!pPosition) cBindClick()
      clickOrderBtn()
    }
  }

  // 结算页优惠列表功能
  function cBindClick() {
    let pList = document.getElementsByClassName('product_li_top')
    let pSelect = document.getElementsByClassName('pop_sku_select')
    let discountLine = document.querySelector('.pop_up_summary_discount')
    let sPrice = document.querySelector('.subtotal_price')
    let tPrice = document.querySelector('.total_price')
    let cPrice = document.querySelector('.pop_up_checkout_price')

    // 点击优惠列表
    if (pList && pList.length > 0) {
      Array.from(pList).forEach(item => {
        item.addEventListener('click', () => {
          if (item.parentNode.className != 'pop_up_product_li product_li_active') {
            Array.from(pList).forEach(val => {
              val.parentNode.className = 'pop_up_product_li'
            })
            productList[item.getAttribute("key")].sku_options.forEach((val, ind) => {
              selectSku(item.getAttribute("key"), val.sku_options, ind, true)
            })
            sPrice.innerHTML = `${item.getAttribute("price_tag")} ${currencyValue}`
            tPrice.innerHTML = `${item.getAttribute("price")} ${currencyValue}`
            cPrice.innerHTML = `${LText.o2d128t} - ${item.getAttribute("price")} ${currencyValue}`
            if (Number(item.getAttribute("discount"))) {
              discountLine.style.display = 'flex'
              discountLine.querySelector('.line_value').innerHTML = `-${item.getAttribute("discount")} ${currencyValue}`
            } else {
              discountLine.style.display = 'none'
            }
            item.parentNode.className = 'pop_up_product_li product_li_active'
          }
        })
      })
    }

    // 下拉选择变体
    if (pSelect && pSelect.length > 0) {
      Array.from(pSelect).forEach(item => {
        item.addEventListener('change', (e) => {
          let productLi = document.getElementsByClassName('pop_up_product_li')
          let name = e.target.getAttribute("name")
          let index = e.target.getAttribute("index")
          let ind = e.target.getAttribute("ind")
          let clickSelect = productList[index]?.sku_options[ind]?.sku_options
          if (clickSelect && clickSelect.length > 0) {
            clickSelect.forEach(item => {
              if (item.name === name) {
                item.selectValue = e.target.value
              }
            })
            selectSku(index, clickSelect, ind, false)
            original = 0
            for (let i = 0; i < skuData.length; i++) {
              original = foAdd(original, Number(skuData[i].price))
            }
            let totalPrice = foSubtract(original, skuData[ind].discount)
            productLi[index].querySelector('img').src = skuData[ind].image
            productLi[index].querySelector('i').innerHTML = `${original} ${currencyValue}`
            productLi[index].querySelector('.span_price').innerHTML = `${totalPrice} ${currencyValue}`
            productLi[index].querySelector('.product_li_top').setAttribute('price_tag', original)
            productLi[index].querySelector('.product_li_top').setAttribute('price', totalPrice)

            sPrice.innerHTML = `${original} ${currencyValue}`
            tPrice.innerHTML = `${totalPrice} ${currencyValue}`
            cPrice.innerHTML = `${LText.o2d128t} - ${totalPrice} ${currencyValue}`
          }
        })
      })
    }
  }

  // 详情页优惠列表功能
  function dBindClick() {
    let pList = document.getElementsByClassName('product_li_top')
    let pSelect = document.getElementsByClassName('pop_sku_select')

    // 点击优惠列表
    if (pList && pList.length > 0) {
      Array.from(pList).forEach(item => {
        item.addEventListener('click', () => {
          if (item.parentNode.className != 'pop_up_product_li product_li_active') {
            Array.from(pList).forEach(val => {
              val.parentNode.className = 'pop_up_product_li'
            })
            productList[item.getAttribute("key")].sku_options.forEach((val, ind) => {
              selectSku(item.getAttribute("key"), val.sku_options, ind, true)
            })
            original = item.getAttribute("price_tag")
            if (Number(item.getAttribute("discount"))) {
              discountPrice = item.getAttribute("discount")
            } else {
              discountPrice = 0
            }
            total = item.getAttribute("price")
            item.parentNode.className = 'pop_up_product_li product_li_active'
          }
        })
      })
    }

    // 下拉选择变体
    if (pSelect && pSelect.length > 0) {
      Array.from(pSelect).forEach(item => {
        item.addEventListener('change', (e) => {
          let productLi = document.getElementsByClassName('pop_up_product_li')
          let name = e.target.getAttribute("name")
          let index = e.target.getAttribute("index")
          let ind = e.target.getAttribute("ind")
          let clickSelect = productList[index]?.sku_options[ind]?.sku_options
          if (clickSelect && clickSelect.length > 0) {
            clickSelect.forEach(item => {
              if (item.name === name) {
                item.selectValue = e.target.value
              }
            })
            selectSku(index, clickSelect, ind, false)
            original = 0
            for (let i = 0; i < skuData.length; i++) {
              original = foAdd(original, Number(skuData[i].price))
            }
            let totalPrice = foSubtract(original, skuData[ind].discount)
            productLi[index].querySelector('img').src = skuData[ind].image
            productLi[index].querySelector('i').innerHTML = `${original} ${currencyValue}`
            productLi[index].querySelector('.span_price').innerHTML = `${totalPrice} ${currencyValue}`
            productLi[index].querySelector('.product_li_top').setAttribute('price_tag', original)
            productLi[index].querySelector('.product_li_top').setAttribute('price', totalPrice)

            total = totalPrice
          }
        })
      })
    }
  }

  // 点击下单按钮
  function clickOrderBtn() {
    let checkoutBtn = document.getElementById('pop_up_checkout_btn')
    checkoutBtn.addEventListener('click', () => {
      if (checkoutBtn.className.indexOf('loading_btn') > 0) {
        return false
      }
      checkoutBtn.className += ' loading_btn'
      checkoutBtn.querySelector('.cod_loading_icon').style.display = 'flex'
      checkoutBtn.querySelector('.cod_loading_icon').style.background = 'rgba(0, 0, 0, 0.6)'
      let params = {
        count: 1,
        shop: Shopify.shop,
        country: Shopify.country,
        country_code: currencyValue,
        name: document.getElementById('cod_name').value,
        phone: document.getElementById('cod_phone').value,
        area: document.getElementById('cod_area').value,
        state: document.getElementById('cod_state').value,
        city: document.getElementById('cod_city').value,
        postcode: document.getElementById('cod_postcode').value,
        email: document.getElementById('cod_email').value.replace(/^\s*|\s*$/g, ''),
      }
      if (LText.lT1p1 === 'RON') {
        params.house_number = document.getElementById('cod_house_number').value
      }
      let isPass = true

      for (let key in params) {
        if (key != 'postcode' && key != 'email' && !params[key]) {
          verifyForm(key)
          isPass = false
          closeLoading(checkoutBtn)
        }
      }
      if (params.phone && params.phone.length != 10) {
        verifyForm('phone', true)
        isPass = false
        closeLoading(checkoutBtn)
      }
      if (isPass) {
        let line_items = []
        if (isDiscounts) {
          skuData.forEach(item => {
            line_items.push({
              product_id: productId,
              quantity: 1,
              variant_id: item.shop_product_id,
            })
          })
          params.combined_sale_id = skuData[0].combined_sale_id
        } else {
          productList.forEach(item => {
            line_items.push({
              product_id: item.product_id,
              quantity: item.quantity,
              variant_id: item.variant_id,
            })
          })
        }
        params.line_items = line_items
        params.source = source
        sendXgtag({
          event_name: "clickPay",
          event_label: "pass",
          event_value: JSON.stringify(params),
        });
        console.log(params)

        fetch(`${URL}/account-service/media_orders/create/pass`, {
          method: 'post',
          body: JSON.stringify(params),
          headers: { 'Content-Type': 'application/json' }
        }).then(
          res => res.json()
        ).then(res => {
          if (res.success) {
            let orderData = res?.data?.detail?.order
            if (orderData) {
              let contents = line_items.map(item => {
                return {
                  id: item.variant_id,
                  quantity: item.quantity,
                }
              })
              sendFbq(
                'Purchase',
                {
                  content_type: 'product',
                  contents: contents,
                  value: orderData?.total_price,
                  currency: orderData?.currency,
                },
                {
                  eventID: orderData?.token || (new Date).getTime() + ""
                }
              )
              sendGtag(
                'Purchase',
                {
                  content_type: 'product',
                  contents: contents,
                  value: orderData?.total_price,
                  currency: orderData?.currency,
                  eventID: orderData?.token || (new Date).getTime() + ""
                }
              )
              sendXgtag({
                event_name: "PlaceOrder",
                event_value: (new Date).getTime() + "",
              });
              sessionStorage.setItem('isSendFbq', '111')
              window.open(orderData?.order_status_url, '_self')
            }
            closeLoading(checkoutBtn)
          } else {
            // timer(res.msg || LText.o2d123u99)
            funOrderSucc()
          }
        }).catch(e => {
          funOrderSucc()
        });
      } else {
        sendXgtag({
          event_name: "clickPay",
          event_label: "no_pass",
          event_value: JSON.stringify(params),
        });
      }
    })
  }

  // 下单成功
  function funOrderSucc() {
    let popUpContent = document.querySelector('.pop_up_content')
    let successDiv = document.querySelector('.order_success')
    let popUpBox = document.querySelector('.pop_up_box')
    popUpContent.style.display = "none"
    successDiv.style.display = "block"
    popUpBox.style.marginTop = "11%"
  }

  // 选择sku事件
  function selectSku(index, sku_options, ind, isAll) {
    if (sku_options && sku_options.length > 0) {
      productSkuList.forEach(varItem => {
        varItem._list = [];
        varItem.skuinfo_list.forEach(item => {
          const _item = sku_options.find(i => (i.selectValue ?? i.value[0]) == item.value);
          if (_item && _item.name === item.name) {
            varItem._list.push(_item)
          }
        })
      })
      let selectOpt = productSkuList.filter(i => i._list && i._list.length === sku_options.length)[0]
      if (isAll && ind === 0) {
        skuData = []
      }
      if (selectOpt) {
        selectOpt.combined_sale_id = productList[index].combined_sale_id
        selectOpt.discount = productList[index].price
      }
      skuData[ind] = selectOpt
    }
  }

  // 验证表单信息错误
  function verifyForm(key, value) {
    let errorBox = document.getElementById(`${key}_error`)
    let errorInp = document.getElementById(`cod_${key}`)
    if (errorBox) {
      if (value) {
        errorBox.innerHTML = LText.ph0n1122
      } else {
        errorBox.innerHTML = LText.e11o1
      }
      errorBox.style.display = 'block'
    }
    if (errorInp) {
      errorInp.className = 'cod_error'
      errorInp.addEventListener('input', function () {
        errorInp.className = ''
        errorBox.style.display = 'none'
      })
    }
  }

  // 定时错误弹窗
  function timer(msg) {
    let messageBox = document.createElement('div')
    messageBox.className = 'pop_up_message'
    messageBox.innerHTML = msg
    document.body.appendChild(messageBox)
    var count = 2;
    let countdown = setInterval(function () {
      count--;
      if (count < 1) {
        clearInterval(countdown);
        return messageBox.remove()
      }
    }, 800)
  }

  // 获取产品数据列表
  async function getProductList(variant_id, quantityNum) {
    if (isDiscounts) {
      createProduct()
    } else {
      Promise.all([clearCart(variant_id, quantityNum)]).then(res => {
        let [data] = res;
        if (data && data.items && data.items.length > 0) {
          data.items = data.items.filter(i => i.id == variant_id)
        }
        if (data && data.items && data.items.length > 0) {
          productList = []
          data.items.forEach(item => {
            productList.push({
              product_id: item.product_id,
              quantity: item.quantity,
              title: item.product_title,
              href: item.url,
              img: item.image,
              variant_id: item.variant_id,
              variant_title: item.variant_title,
              price: parseFloat(item.final_line_price / 100),
              // unit: currencyList[data.currency] ? currencyList[data.currency] : data.currency,
              unit: currencyValue,
              // total_price: parseFloat(data.total_price / 100),
            })
          })
          createProduct()
        }
      })
    }
  }

  // 检查产品是否为组合销售
  function checkData() {
    return new Promise(resolve => {
      fetch(`${URL}/account-service/combined_sale_template/pass/check?shop_product_id=${productId}`, {
        method: 'get',
      }).then(
        res => res.json()
      ).then(res => {
        resolve(res);
      }).catch(e => {
        resolve('');
      });
    })
  }

  // 获取商品数据接口
  function getSKUData() {
    return new Promise(resolve => {
      fetch(`${URL}/account-service/combined_sale_template/pass/get?shop_product_id=${productId}`, {
        method: 'get',
      }).then(
        res => res.json()
      ).then(res => {
        resolve(res);
      }).catch(e => {
        resolve('');
      });
    })
  }

  // 获取购物车接口
  function getCart() {
    return new Promise(resolve => {
      fetch(`${window.location.origin}/cart.js?timestamp=${Date.parse(new Date())}`, {
        method: 'get',
      }).then(
        res => res.json()
      ).then(res => {
        resolve(res);
      }).catch(e => {
        resolve('');
      });
    });
  }

  // 清空购物车接口
  function clearCart(id, quantityNum) {
    return new Promise(resolve => {
      fetch(`${window.location.origin}/cart/clear.js`, {
        method: 'post',
        // body: JSON.stringify(obj),
        headers: { 'Content-Type': 'application/json' }
      }).then(
        res => res.json()
      ).then(res => {
        if (id) {
          updateCart(id, quantityNum).then(reso => {
            resolve(reso)
            cartCreat()
            sendFbq('AddToCart', {}, { eventID: (new Date).getTime() + "" })
            sendGtag('add_to_cart', { eventID: (new Date).getTime() + "", url: window.location.href })
            sendXgtag({ event_name: "AddCart" });
          })
        } else {
          resolve(res);
        }
      }).catch(e => {
        resolve('');
      });
    });
  }

  // 更新购物车接口
  function updateCart(id, quantityNum) {
    let obj = {};
    obj[id] = quantityNum;
    return new Promise(resolve => {
      fetch(`${window.location.origin}/cart/update.js`, {
        method: 'post',
        body: JSON.stringify({ updates: obj }),
        headers: { 'Content-Type': 'application/json' }
      }).then(
        res => res.json()
      ).then(res => {
        resolve(res);
      }).catch(e => {
        resolve('');
      });
    });
  }

  // 循环间隔动画效果
  if (buyBtn.classList && buyBtn.classList.length > 0) {
    setInterval(() => {
      if (buyBtn.className.indexOf('animate__animated') > -1) {
        buyBtn.classList.remove('animate__animated')
        buyBtn.classList.remove('animate__tada')
      } else {
        buyBtn.classList.add('animate__animated')
        buyBtn.classList.add('animate__tada')
      }
    }, 2000)
  }

  // 判断按钮距离顶部距离
  if (window.location.pathname.indexOf('/products/') > -1 && window.screen.width < 500) {
    window.addEventListener('scroll', function () {
      //检测滚走的高度
      let codBottomButton = document.querySelector('.cod_bottom_button')
      var offsetT = buyBtn.getBoundingClientRect().top;
      if (offsetT < -50) {
        codBottomButton.style.display = 'flex'
      } else {
        codBottomButton.style.display = 'none'
      }
    });
  }
  // 加购记录
  if (getReferer() && getReferer().split('.com')[0].indexOf(window.location.host.split('.com')[0]) === -1 && (!localStorage.getItem('refererName') || (localStorage.getItem('refererName') && localStorage.getItem('refererName') !== getReferer()))) {
    localStorage.setItem('refererName', getReferer())
  }
  function cartCreat() {
    if (window.location.pathname.indexOf('/products/') > -1 && source) {
      let params = {
        source: source,
        url: window.location.href,
      }
      fetch(`${URL}/account-service/media_orders/cart_creat/pass`, {
        method: 'post',
        body: JSON.stringify(params),
        headers: { 'Content-Type': 'application/json' }
      }).then(
        res => res.json()
      ).then(res => {
      }).catch(e => {
      });
    }
  }

  // 获取referrer
  function getReferer() {
    if (document.referrer) {
      return document.referrer;
    } else {
      return false;
    }
  }

  // FBQ
  function sendFbq(a, b, c) {
    if ("function" == typeof window.fbq) {
      window.fbq("track", a, b, c)
    }
  }

  // gtag
  function sendGtag(a, b) {
    if ("function" == typeof window.gtag) {
      window.gtag("event", a, b)
    }
  }
  // sendXgtag
  function sendXgtag(data) {
    if (!isMonitor) return
    let sym = location.search.indexOf('?') > -1 ? "&" : "?"
    let url = location.search.indexOf('source') > -1 ? location.href : location.href + sym + window.localStorage.getItem("sourceObj")
    let obj = {
      time_stamp: new Date().getTime() + "",
      cl: Shopify.country || "",
      procudt_id: meta?.product?.id || "",
      user_ID: myUUID,
      UA: navigator.userAgent,
      url: url,
    };
    const params = { ...data, ...obj };
    fetch(`https://www.xgoodspic.com/?${new URLSearchParams(params)}`, {
      method: 'get',
    }).then(
      res => res.json()
    ).then(res => {
    }).catch(e => {
    });
  }

  let events = []
  let copyEvents = []
  startRecording()
  function startRecording() {
    if (!isMonitor) return
    try {
      rrweb.record({
        emit(event) {
          // 将 event 存入 events 数组中
          events.push(event);
        },
      });
      // 每 10 秒调用一次保存录制数据的方法
      setInterval(() => {
        saveEvents();
      }, 10000);
    } catch (error) { }
  }
  function saveEvents() {
    let timeList = copyEvents.map((i) => {
      return i.timestamp;
    });
    let filterList = events.filter(
      (item) => timeList.indexOf(item.timestamp) === -1
    );
    copyEvents = copyEvents.concat(filterList);
    fetch(`https://cod.xgoodspic.com/record/rrweb/${location.host}/${myUUID}`, {
      method: 'post',
      body: JSON.stringify(filterList),
      headers: { 'Content-Type': 'application/json' }
    }).then(
      res => res.json()
    ).then(res => {
    }).catch(e => {
    });
  }


}())